var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatementNavigator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.745 9.9817L20.245 10.0121C20.5949 10.0131 20.829 9.78043 20.83 9.43043C20.831 9.08044 20.5983 8.84643 20.2483 8.84542L9.74837 8.81504C9.39837 8.81403 9.16436 9.04669 9.16335 9.39669C9.16234 9.74668 9.395 9.98069 9.745 9.9817Z",
    fill: "#A3A3A3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2348 13.5121L13.2349 13.4918C12.8849 13.4908 12.6508 13.7235 12.6498 14.0735C12.6488 14.4235 12.8815 14.6575 13.2315 14.6585L20.2315 14.6787C20.5815 14.6797 20.8155 14.4471 20.8165 14.0971C20.8175 13.7471 20.5848 13.5131 20.2348 13.5121Z",
    fill: "#A3A3A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5481 18.1652L20.2213 18.1787C20.5713 18.1797 20.804 18.4137 20.803 18.7637C20.802 19.1137 20.568 19.3464 20.218 19.3454L15.5447 19.3319C15.1947 19.3308 14.9621 19.0968 14.9631 18.7468C14.9641 18.3968 15.1981 18.1642 15.5481 18.1652Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatementNavigator);
export default __webpack_public_path__ + "static/media/statement-navigator.445dcfe4a965e545c9cd7772fdc616f3.svg";
export { ForwardRef as ReactComponent };